// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_feff07dc","icon":"_5a8bc44f","hasUnread":"_e3cf56d7","navigationRefreshWrapper":"_a56fc740"};